import SdUtilityEntryPoint from "./SdUtilityEntryPoint";

export default SdUtilityEntryPoint;
